import { ChangeDetectionStrategy, Component, TemplateRef, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'hypecast-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent {
    readonly templateRef = input<TemplateRef<any>>();
    readonly isLoading = input<boolean>();
    readonly cssClass = input<string>();
    readonly options = input<{width?: string; height?: string; marginTop?: string; marginBottom?: string}>();
}
